import { render, staticRenderFns } from "./helpNotif.vue?vue&type=template&id=1dcb43dd&"
import script from "./helpNotif.vue?vue&type=script&lang=js&"
export * from "./helpNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports